import { Injectable } from '@angular/core';
import { LocalStorageKeys } from 'src/app/core/constants/constants';
import { isShopifyEmbeddedContext } from 'src/app/core/helpers/shopify-context.helper';

// Single chokepoint for reading/writing the Xoopah access token. Embedded Shopify sessions
// keep it in memory only (Shopify requirement 1.1.1 flags third-party storage reliability for
// embedded apps, and a page reload re-derives the token anyway via bootstrapInstallation).
// Every other flow (plain login, Google/Facebook, onboarding) is untouched and keeps using
// localStorage exactly as before.
@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private embeddedToken: string | null = null;

  getToken(): string | null {
    if (isShopifyEmbeddedContext()) {
      return this.embeddedToken;
    }
    return localStorage.getItem(LocalStorageKeys.Token);
  }

  setToken(token: string): void {
    if (isShopifyEmbeddedContext()) {
      this.embeddedToken = token;
      return;
    }
    localStorage.setItem(LocalStorageKeys.Token, token);
  }

  clearToken(): void {
    this.embeddedToken = null;
    localStorage.removeItem(LocalStorageKeys.Token);
  }

  hasToken(): boolean {
    return !!this.getToken();
  }
}
